<template>
    <div class="show">
        <!-- 通过condtionSkip控制条件显示 -->
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <div class="item-wrap">
            <div class="item">
                <me-cell center title="标签必填">
                    <template #right-icon>
                        <me-switch
                            v-model="labelRequired"
                            active-color="#06B455"
                            inactive-color="#DBDBDB"
                            size="24"
                        />
                    </template>
                </me-cell>
            </div>
        </div>
        <me-popup v-model="showRequiredCountPicker" position="bottom">
            <me-picker
                v-if="showRequiredCountPicker"
                :key="requiredCountPickerKey"
                title="必填数量"
                show-toolbar
                :columns="requiredCountColumns"
                @confirm="onRequiredCountConfirm"
                @change="onRequiredCountChange"
                @cancel="showRequiredCountPicker = false"
            />
        </me-popup>
        <div class="tip">按分值设置对应标签</div>
        <div class="content">
            <div class="label">
                <ul class="list">
                    <li
                     class="item"
                     v-for="item in score"
                     :key="item"
                     :class="{active: index==item}"
                     @click="setLabel(item)">{{item}}</li>
                </ul>
                <div class="label-desc-block" :class="{ 'has-required-count': labelRequired }">
                    <me-cell
                        v-if="labelRequired"
                        center
                        title="必填数量"
                        class="label-desc-row"
                        clickable
                        @click="showRequiredCountPicker = true"
                    >
                        <template #default>
                            <span class="count-value-wrap">
                                <span class="count-value">{{ requiredCountDisplay }}</span>
                                <me-icon name="arrow" class="count-arrow" />
                            </span>
                        </template>
                    </me-cell>
                    <div class="desc">设置标签<span>（ 每行最多10个字，最多20行 ）</span></div>
                    <me-field
                        v-model="labelJson[index]"
                        ref="textarea"
                        @focus="addEventListenerForInput"
                        @blur="removeEventListenerForInput"
                        class="options custom-area"
                        :style="{paddingBottom: addPadding ? '400PX' : '.7rem', height: addPadding ? 'calc(12rem + 400PX)' : '12rem'}"
                        autosize
                        label=""
                        type="textarea"
                        placeholder="请输入"/>
                </div>
            </div>
        </div>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import { Questionnaire } from '@/network'
import { addClass2, removeClass2 } from '@/util/status-util'
import { getStorage } from '@/util/common'
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import confirm from '../compontents/confirm.vue'
import browser from '@/util/browser'

export default {
    name: 'show',
    components: { confirm },
    data() {
        const minMaxOptions = Array.from({ length: 20 }, (_, i) => ({
            text: String(i + 1),
            value: i + 1,
        }))
        return {
            title: '标签',
            score: 0,
            message: '',
            addPadding: false,
            index: null,
            nps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            labelJson: {},
            isCustomLeft: false,
            labelRequired: true,
            requiredCount: {}, // { [score]: { minCount, maxCount } } 每个分值独立的必填数量
            showRequiredCountPicker: false,
            minMaxOptions,
            tempRequiredCountMin: 1,
            tempRequiredCountMax: 20,
        }
    },
    computed: {
        requiredCountDisplay() {
            const { minCount, maxCount } = this.getRequiredCountForIndex(this.index)
            if (minCount === maxCount) {
                return `${minCount}项`
            }
            return `${minCount}-${maxCount}`
        },
        requiredCountColumns() {
            const rc = this.getRequiredCountForIndex(this.index)
            const min = (this.tempRequiredCountMin != null ? this.tempRequiredCountMin : rc.minCount)
            const max = Math.max(min, Math.min((this.tempRequiredCountMax != null ? this.tempRequiredCountMax : rc.maxCount), 20))
            const minCol = this.minMaxOptions
            const maxCol = this.minMaxOptions.slice(min - 1)
            const minIndex = min - 1
            const maxIndex = Math.min(max - min, maxCol.length - 1)
            return [
                { values: minCol, defaultIndex: minIndex },
                { values: maxCol, defaultIndex: maxIndex },
            ]
        },
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
        type() {
            return this.$route.params.type
        },
        requiredCountPickerKey() {
            const rc = this.getRequiredCountForIndex(this.index)
            const min = this.tempRequiredCountMin != null ? this.tempRequiredCountMin : rc.minCount
            const max = this.tempRequiredCountMax != null ? this.tempRequiredCountMax : rc.maxCount
            return `${this.index}-${min}-${max}`
        },
    },
    created() {
       removeClass2('body', 'loading')
       const { guaguaApp } = browser
        if (guaguaApp) {
            this.isCustomLeft = guaguaApp
        }
       let { score, labelJson, labelRequired, requiredCount } = this.$store.state.labelObj || {}
       this.score = this.type === 'nps' ? this.nps : score / 1
       this.index = this.type === 'nps' ? 0 : 1
       this.labelJson = labelJson || {}
       this.labelRequired = labelRequired != null && labelRequired !== undefined ? !!labelRequired : true
       let rc = requiredCount
       if (typeof rc === 'string') {
           try { rc = JSON.parse(rc) } catch (e) { rc = {} }
       }
       this.requiredCount = rc && typeof rc === 'object' ? rc : {}
       const defaultRc = this.getRequiredCountForIndex(this.index)
       this.tempRequiredCountMin = defaultRc.minCount
       this.tempRequiredCountMax = defaultRc.maxCount
    },
    mounted() {
        this.$nextTick(() => {
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
            window.scrollTo(0, 0)
        })
    },
    watch: {
        showRequiredCountPicker(val) {
            if (val) {
                const rc = this.getRequiredCountForIndex(this.index)
                this.tempRequiredCountMin = rc.minCount
                this.tempRequiredCountMax = rc.maxCount
            }
        },
    },
    mixins: [mixin],
    methods: {
        getRequiredCountForIndex(idx) {
            const rc = (this.requiredCount || {})[idx]
            return {
                minCount: rc && rc.minCount != null ? rc.minCount : 1,
                maxCount: rc && rc.maxCount != null ? rc.maxCount : 20,
            }
        },
        setLabel(index) {
            this.index = index
        },
        onRequiredCountChange(picker, values, index) {
            if (index === 0 && values && values[0]) {
                const newMin = values[0].value || values[0]
                this.tempRequiredCountMin = newMin
                if (this.tempRequiredCountMax < newMin) {
                    this.tempRequiredCountMax = newMin
                    this.$nextTick(() => {
                        if (picker && picker.setColumnValues) {
                            const maxCol = this.minMaxOptions.slice(newMin - 1)
                            picker.setColumnValues(1, maxCol)
                        }
                    })
                }
            } else if (index === 1 && values && values[1]) {
                const newMax = values[1].value || values[1]
                this.tempRequiredCountMax = newMax
            }
        },
        onRequiredCountConfirm(value) {
            let min = 1
            let max = 20
            if (Array.isArray(value)) {
                const minVal = value[0]
                const maxVal = value[1]
                min = (minVal && (minVal.value != null ? minVal.value : minVal)) || 1
                max = (maxVal && (maxVal.value != null ? maxVal.value : maxVal)) || 20
            }
            if (max < min) max = min
            this.$set(this.requiredCount, this.index, { minCount: min, maxCount: max })
            this.showRequiredCountPicker = false
        },
        confirm() {
            const { score, labelJson, labelRequired, requiredCount } = this
            let labelOption = '0'
            let lengthCheck = false
            let lineCheck = false
            let repeatCheck = false
            for (let [index, labels] of Object.entries(labelJson || {})) {
                if (labels) {
                    labels = labels.split('\n').filter(item => item)
                    new Set(labels).size !== labels.length ? repeatCheck = true : null
                    if (repeatCheck) {
                        Toast.fail('标签值不可重复')
                        return
                    }
                    labels = labels.join('\n')
                    labelJson[index] = labels
                    labelOption = '1'
                    labels.split('\n').some(item => item.length > 10) ? lengthCheck = true : null
                    labels.split('\n').length > 20 ? lineCheck = true : null
                }
            }
            if (lengthCheck) {
                Toast.fail('每行不能超过10个字')
                return
            }
            if (lineCheck) {
                Toast.fail('最多20行')
                return
            }
            if (labelRequired) {
                const scoresToCheck = this.type === 'nps' ? this.nps : [this.index]
                const invalidScores = []
                for (const idx of scoresToCheck) {
                    const { minCount, maxCount } = this.getRequiredCountForIndex(idx)
                    // minCount为1时不校验标签数量
                    if (minCount === 1) continue
                    const currentLabels = (labelJson || {})[idx]
                    const labelArr = (currentLabels && typeof currentLabels === 'string')
                        ? currentLabels.split('\n').filter(item => item && item.trim())
                        : []
                    // 标签数量需满足：至少 minCount 个（用户最少要选 minCount 个）；最多选 maxCount 只是上限，标签少时用户少选即可
                    if (labelArr.length < minCount) {
                        invalidScores.push(idx)
                    }
                }
                if (invalidScores.length) {
                    Toast.fail(`设置标签数量不满足必填数量需求：分值${invalidScores.join('、')}`)
                    return
                }
            }
            this.$store.commit('updateLabelObj', {
                score,
                labelJson,
                labelOption,
                labelRequired: labelRequired || false,
                requiredCount: labelRequired ? requiredCount : {},
            })
            if (this.topicId) {
                this.$router.back({
                    name: 'topic2',
                    params: {
                        pageId: this.pageId,
                        topicId: this.topicId,
                    },
                })
                return
            }
            this.$router.back({
                name: 'topic',
                params: {
                    type: this.type,
                    pageId: this.pageId,
                },
            })
        },
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                const refTextarea = this.$refs.textarea.$el
                const st = document.documentElement.scrollTop || document.body.scrollTop
                const ot = refTextarea.offsetTop
                const ob = window.innerHeight - ot + st - refTextarea.offsetHeight
                const keyH = 400; //软键盘的高度
                this.addPadding = true
                // if (ob < keyH) {
                //     this.$nextTick(() => {
                //         document.documentElement.scrollTop = st + keyH - ob
                //         document.body.scrollTop = st + keyH - ob
                //     })
                // }
            }
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = false
            }
        },
    },

}
</script>
<style scoped lang="scss">
    .item-wrap {
        margin: 0 .4rem .4rem .4rem;
        .item {
            background: #FBFBFC;
            border-radius: 6px;
            overflow: hidden;
            ::v-deep .me-cell {
                border-radius: 6px;
                &::after {
                    display: none;
                }
                padding: 0.43rem .43rem .43rem 0;
                background: #FBFBFC;
                border-bottom: 1px solid #F2F4F6;
                padding-left: 0;
                color: #222;
                line-height: .54rem;
                font-size: .38rem;
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
    .tip{
        line-height: 1.14rem;
        background: #fff;
        padding-left: .32rem;
        color: #9298A8;
        font-size: .34rem;
    }
    .content{
        padding: .42rem .42rem 1.73333rem;
        .list{
            margin-left: -.32rem;
            display: flex;
            flex-wrap: wrap;
            .item{
                margin-bottom: .42rem;
                margin-left: .32rem;
                width: 1.57rem;
                line-height: .82rem;
                background: #fff;
                text-align: center;
                border-radius: .16rem;
                &.active{
                    background: #06B455;
                    color: #fff;
                }
            }
        }
        .label-desc-block {
            background: #fff;
            border-radius: .16rem;
            overflow: hidden;
            ::v-deep .me-cell.label-desc-row {
                padding: 0 .4rem;
                min-height: 1.14rem;
                line-height: 1.14rem;
                font-size: .37rem;
                color: #333333;
                background: #fff;
                border-bottom: 1px solid #F2F4F6;
                border-radius: .16rem .16rem 0 0;
                display: flex;
                align-items: center;
                &::after {
                    display: none;
                }
                .count-value-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                }
                .count-value-wrap .count-value {
                    margin-right: 0.08rem;
                }
                .count-arrow {
                    color: #c8c9cc;
                    font-size: 0.36rem;
                }
            }
            .desc {
                line-height: 1.14rem;
                background: #fff;
                border-bottom: 1px solid #F2F4F6;
                padding: 0 .4rem;
                color: #333333;
                font-size: .37rem;
                > span {
                    font-size: .32rem;
                    color: #9298A8;
                }
            }
            &:not(.has-required-count) .desc {
                border-radius: .16rem .16rem 0 0;
            }
        }
    }
    ::v-deep .label-desc-block .me-field,
    ::v-deep .label-desc-block .me-field .me-cell {
        border-radius: 0 0 .16rem .16rem;
    }
    ::v-deep .me-field__body{
        height: 100%;
        align-items: flex-start;
    }
    ::v-deep .me-field__control{
        height: 100%!important;
    }

</style>
